import * as Sentry from '@sentry/angular';
import { Injectable } from '@angular/core';
import { B2cResponse } from '../types/common.model';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private readonly STORAGE_KEY = 'b2c_auth_response';

  saveB2cResponse(response: B2cResponse): void {
    try {
      const serialized = JSON.stringify(response);
      localStorage.setItem(this.STORAGE_KEY, serialized);
    } catch (error) {
      Sentry.captureException(error);
      console.error('Error saving to localStorage:', error);
    }
  }

  getB2cResponse(): B2cResponse | null {
    try {
      const data = localStorage.getItem(this.STORAGE_KEY);
      return data ? (JSON.parse(data) as B2cResponse) : null;
    } catch (error) {
      Sentry.captureException(error);
      console.error('Error retrieving from localStorage:', error);
      return null;
    }
  }

  clearB2cResponse(): void {
    try {
      localStorage.removeItem(this.STORAGE_KEY);
    } catch (error) {
      Sentry.captureException(error);
      console.error('Error clearing localStorage:', error);
    }
  }

  isAuthenticated(): boolean {
    return this.getB2cResponse() !== null;
  }
}
